var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 39,
    viewBox: "0 0 35 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.75862C0 1.23448 1.23448 0 2.75862 0H17.2414C17.6069 0 17.9573 0.144785 18.2166 0.404095L27.1821 9.36961C27.4414 9.62754 27.5862 9.97931 27.5862 10.3448V17.3626C26.3076 16.844 24.9131 16.5517 23.4483 16.5517C17.3545 16.5517 12.4138 21.4924 12.4138 27.5862C12.4138 30.8869 13.8699 33.84 16.1665 35.8621H2.75862C1.23448 35.8621 0 34.6276 0 33.1034V2.75862ZM24.9596 11.0345L16.5517 2.62662V9.65517C16.5517 10.4166 17.1697 11.0345 17.931 11.0345H24.9596ZM23.4483 19.3103C18.894 19.3103 15.1724 23.0319 15.1724 27.5862C15.1724 32.1405 18.894 35.8621 23.4483 35.8621C25.2297 35.8621 26.8791 35.287 28.2328 34.3211L32.1282 38.2166C32.4742 38.5769 32.9879 38.7221 33.4713 38.5961C33.9546 38.4701 34.3321 38.0926 34.4581 37.6092C34.5841 37.1258 34.439 36.6121 34.0787 36.2662L30.1832 32.3707C31.1491 31.017 31.7241 29.3676 31.7241 27.5862C31.7241 23.0319 28.0026 19.3103 23.4483 19.3103ZM28.9655 27.5862C28.9655 24.5228 26.5117 22.069 23.4483 22.069C20.3848 22.069 17.931 24.5228 17.931 27.5862C17.931 30.6496 20.3848 33.1034 23.4483 33.1034C26.5117 33.1034 28.9655 30.6496 28.9655 27.5862Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.a63255ff71dfdc2ad8d39de0ff93d873.svg";
export { ForwardRef as ReactComponent };